import { RotateCw } from "lucide-react";

export const isNotFound = (error) => error?.response?.status === 404;

export function LoadError({ onRetry }) {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="load-error">
      <p className="font-serif text-3xl font-bold text-foreground">This page didn&apos;t load</p>
      <p className="mt-3 text-muted-foreground">The connection hiccuped. Please try again.</p>
      <button type="button" onClick={() => onRetry()} data-testid="load-error-retry"
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform duration-200 hover:-translate-y-0.5">
        <RotateCw className="h-4 w-4" /> Try again
      </button>
    </div>
  );
}
